import React from 'react'
import { CustomerAccountContext } from '../contexts/customer-account-context'
import CustomerDetailsWidget from '../container/customer-details-widget';
import CustomerIntegrationWidget  from '../container/customer-integrations-widget';
import CustomerLoginsWidget from '../container/customer-logins-widget'
import CustomerStatisticsWidget from '../container/customer-statistics-widget'

const CustomerInformation = (props) => (
    <CustomerAccountContext.Consumer>
        { ({ account, refreshCustomer }) => (
            <div>
                <CustomerDetailsWidget account={account} {...props}/>
                <CustomerIntegrationWidget refreshCustomer={refreshCustomer} account={account}/>
                <CustomerLoginsWidget account={account}/>
                <CustomerStatisticsWidget account={account}/>
            </div>
        )}
    </CustomerAccountContext.Consumer>
)

export default CustomerInformation